module.exports = __webpack_public_path__ + "img/boot_reis.069015ba.jpg";